module.exports = __webpack_public_path__ + "static/media/4ODA13.72fdc3c5.jpg";